import * as bestPlateTypes from "./bestPlate.type";

import { API } from "../../../services/http.service";

const REQUEST_URL = "";

// En İyi Tabak - Haftanın oylamadaki tabakları
export const getVotingList = () => async (dispatch) => {
  dispatch({ type: bestPlateTypes.GET_BEST_PLATE_VOTING_PENDING });
  try {
    const response = await API.get(`${REQUEST_URL}/game/bestPlate/voting`);
    dispatch({
      type: bestPlateTypes.GET_BEST_PLATE_VOTING_FULFILLED,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: bestPlateTypes.GET_BEST_PLATE_VOTING_REJECTED,
      payload: error,
    });
    return Promise.reject(error);
  }
};

// En İyi Tabak - Oy ver
export const doVote =
  (competitionId, competitionPhotoId) => async (dispatch) => {
    dispatch({ type: bestPlateTypes.SET_BEST_PLATE_VOTE_PENDING });

    const data = { competitionId, competitionPhotoId };

    try {
      const response = await API.post(`${REQUEST_URL}/game/bestPlate/vote`, data);
      dispatch({
        type: bestPlateTypes.SET_BEST_PLATE_VOTE_FULFILLED,
        payload: response,
      });
      return Promise.resolve(response);
    } catch (error) {
      dispatch({
        type: bestPlateTypes.SET_BEST_PLATE_VOTE_REJECTED,
        payload: error,
      });
      return Promise.reject(error);
    }
  };

// En İyi Tabak - Fotoğraflarım
export const getMyPlates = () => async (dispatch) => {
  dispatch({ type: bestPlateTypes.GET_BEST_PLATE_MY_PHOTOS_PENDING });
  try {
    const response = await API.get(`${REQUEST_URL}/game/bestPlate/myPhotos`);
    dispatch({
      type: bestPlateTypes.GET_BEST_PLATE_MY_PHOTOS_FULFILLED,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: bestPlateTypes.GET_BEST_PLATE_MY_PHOTOS_REJECTED,
      payload: error,
    });
    return Promise.reject(error);
  }
};

// En İyi Tabak - Fotoğraf yükle / değiştir (multipart)
export const uploadPlate = (title, description, file, id) => async (dispatch) => {
  dispatch({ type: bestPlateTypes.SET_BEST_PLATE_UPLOAD_PENDING });

  const formData = new FormData();
  const uploadBestPlateDTO = { id: id || null, title, description };
  formData.append("uploadBestPlateDTO", JSON.stringify(uploadBestPlateDTO));
  if (file instanceof File) {
    formData.append("file", file);
  }

  try {
    const response = await API.post(
      `${REQUEST_URL}/game/bestPlate/upload`,
      formData,
      {
        headers: {
          "X-Tenant": localStorage.getItem("tenantName"),
        },
      }
    );
    dispatch({
      type: bestPlateTypes.SET_BEST_PLATE_UPLOAD_FULFILLED,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: bestPlateTypes.SET_BEST_PLATE_UPLOAD_REJECTED,
      payload: error,
    });
    return Promise.reject(error);
  }
};

// En İyi Tabak - Yükleme kilidi (birincilik tekrar kuralı) + aktif tema
export const getStatus = () => async (dispatch) => {
  dispatch({ type: bestPlateTypes.GET_BEST_PLATE_STATUS_PENDING });
  try {
    const response = await API.get(`${REQUEST_URL}/game/bestPlate/status`);
    dispatch({
      type: bestPlateTypes.GET_BEST_PLATE_STATUS_FULFILLED,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: bestPlateTypes.GET_BEST_PLATE_STATUS_REJECTED,
      payload: error,
    });
    return Promise.reject(error);
  }
};

// En İyi Tabak - Haftanın birincisi ve arşiv
export const getWinners = () => async (dispatch) => {
  dispatch({ type: bestPlateTypes.GET_BEST_PLATE_WINNERS_PENDING });
  try {
    const response = await API.get(`${REQUEST_URL}/game/bestPlate/winners`);
    dispatch({
      type: bestPlateTypes.GET_BEST_PLATE_WINNERS_FULFILLED,
      payload: response,
    });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: bestPlateTypes.GET_BEST_PLATE_WINNERS_REJECTED,
      payload: error,
    });
    return Promise.reject(error);
  }
};
